module.exports = __webpack_public_path__ + "img/Sanskrit.eaedda38.jpeg";